<template lang="pug">
  v-container(fluid)
    Search(:organizations="organizations" :title="title" :loading="loading")
</template>

<script>
import organizationService from '../service.js'
import Search from '../components/SearchList'
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      organizations: [],
      title: null,
      loading: true
    }
  },
  components: {
    Search
  },
  computed: {
    ...mapGetters('global', ['search'])
  },
  watch: {
    search(val) {
      this.searchInOrganization(val)
    }
  },
  created() {
    // if (!this.$route.params || !this.$route.params.id) return this.$router.push("/location")
    this.searchInOrganization(this.search)
  },
  methods: {
    searchInOrganization(val) {
      // if (!this.$route.params) return this.$router.push("/location")
      this.title = this.search
      this.loading = true
      organizationService.search({search: val})
      .then(result => {
        this.organizations = result.data
        this.loading = false
        console.log('saqib', result)
      })
    }
   
  }
}
</script>

<style scoped>
</style>